import { FC, ReactNode } from "react";
import { BillsIcon } from "./icons/BillsIcon";
import { CycleIcon } from "./icons/CycleIcon";
import { ShieldIcon } from "./icons/ShieldIcon";
import { SnowflakeIcon } from "./icons/SnowflakeIcon";

enum CommunityViewKey {
  CommunityViewsAboutTokenUtility = "communityViewsAboutTokenUtility",
  CommunityViewsAboutTokenPrice = "communityViewsAboutTokenPrice",
  CommunityViewsAboutProjectSecurity = "communityViewsAboutProjectSecurity",
  CommunityViewsAboutProjectEcosystem = "communityViewsAboutProjectEcosystem",
}

const communityViewKeyToDisplayName: Record<CommunityViewKey, string> = {
  [CommunityViewKey.CommunityViewsAboutTokenUtility]: "Views about utility",
  [CommunityViewKey.CommunityViewsAboutTokenPrice]: "Views about price",
  [CommunityViewKey.CommunityViewsAboutProjectSecurity]: "Views about security",
  [CommunityViewKey.CommunityViewsAboutProjectEcosystem]:
    "Views about ecosystem",
};

const communityViewKeyToIcon: Record<CommunityViewKey, ReactNode> = {
  [CommunityViewKey.CommunityViewsAboutTokenUtility]: (
    <CycleIcon className="w-6 min-w-6 max-w-6 h-6 min-h-6 max-h-6" />
  ),
  [CommunityViewKey.CommunityViewsAboutTokenPrice]: (
    <BillsIcon className="w-6 min-w-6 max-w-6 h-6 min-h-6 max-h-6" />
  ),
  [CommunityViewKey.CommunityViewsAboutProjectSecurity]: (
    <ShieldIcon className="w-6 min-w-6 max-w-6 h-6 min-h-6 max-h-6" />
  ),
  [CommunityViewKey.CommunityViewsAboutProjectEcosystem]: (
    <SnowflakeIcon className="w-6 min-w-6 max-w-6 h-6 min-h-6 max-h-6" />
  ),
};

const communityViewsOrder: CommunityViewKey[] = [
  CommunityViewKey.CommunityViewsAboutTokenUtility,
  CommunityViewKey.CommunityViewsAboutTokenPrice,
  CommunityViewKey.CommunityViewsAboutProjectSecurity,
  CommunityViewKey.CommunityViewsAboutProjectEcosystem,
];

export const InTheEyesOfCommunity: FC<{
  data: Record<CommunityViewKey, string[]>;
  className?: string;
}> = ({ data, className }) => {
  return (
    <div
      className={`flex flex-col bg-[#55A6FB1A] p-5 rounded-xl gap-6 flex-1 ${className || ""}`}
    >
      <div className="text-[16px] font-medium">
        In the eyes of the Community
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
        {communityViewsOrder.map((key) => (
          <div
            key={key}
            className="flex flex-col gap-4 bg-[rgba(255,255,255,0.05)] rounded-xl p-4"
          >
            <div className="text-white font-normal text-sm">
              {communityViewKeyToDisplayName[key]}
            </div>
            <ul>
              {data[key].map((text) => (
                <ol
                  key={text}
                  className="flex items-start gap-2 mb-[10px] pb-[10px] last:mb-0 last:pb-0 border-b border-solid border-b-[rgba(255,255,255,0.05)] last:border-none"
                >
                  {communityViewKeyToIcon[key]}
                  <div className="text-white font-normal text-sm">{text}</div>
                </ol>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
